import green from '@material-ui/core/colors/green'
import red from '@material-ui/core/colors/red'

export const styles = () => ({
  icon: {
    alignSelf: 'flex-end'
  },

  greenIcon: {
    color: green['A400']
  },

  redIcon: {
    color: red['500']
  }
})



// WEBPACK FOOTER //
// ./src/components/PassengerFields/styles.js